export const intro = {
  tour: {
    title: 'One piece at a time',
    para: "Go through the form one piece at a time, each subsection on it's own page.",
    button: 'Take me to the first section',
  },
  review: {
    title: 'Full section view',
    para: 'See the entire section including all subsections on one page.',
    button: 'Show me the full section',
  },
  errors: 'Looks like we have a few issues, how would you like to fix them?',
  neutral: 'Looks like you still have some items left, how would you like to finish them?',
  complete: 'Everything looks good here but you can still review your answers.',
};
